export default "__VITE_ASSET__CLSIBp3J__"